export const TIMER_VALUE = 60;
